import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { MediaPlayerProvider } from './contexts/MediaPlayerContext';
import { ArtistDataProvider } from './context/ArtistDataContext';

// B UI imports (now the default)
import { BPinEntry } from './b/components/BPinEntry';
import { BSearchPage } from './b/pages/BSearchPage';
import { BResultsPage } from './b/pages/BResultsPage';
import { BBookmarksPage } from './b/pages/BBookmarksPage';

// Classic UI imports (available at /classic)
import { SearchPage } from './pages/SearchPage';
import { ResultsPage } from './pages/ResultsPage';

// Redirect helper for /b/report/:reportId -> /report/:reportId
function RedirectToReport() {
  const { reportId } = useParams();
  return <Navigate to={`/report/${reportId}`} replace />;
}

export function App() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    // Check for existing session
    const session = localStorage.getItem('tastymusic_session');
    setIsAuthenticated(session === 'authenticated');
  }, []);

  // Loading state while checking auth
  if (isAuthenticated === null) {
    return null;
  }

  // Show PIN entry if not authenticated (using new B UI styling)
  if (!isAuthenticated) {
    return <BPinEntry onSuccess={() => setIsAuthenticated(true)} />;
  }

  // Show main app with routing
  return (
    <BrowserRouter>
      <ArtistDataProvider>
        <MediaPlayerProvider>
          <Routes>
            {/* B UI routes (now the default) */}
            <Route path="/" element={<BSearchPage />} />
            <Route path="/report/:reportId" element={<BResultsPage />} />
            <Route path="/research" element={<BResultsPage />} />
            <Route path="/bookmarks" element={<BBookmarksPage />} />

            {/* Legacy /b paths redirect to root equivalents */}
            <Route path="/b" element={<Navigate to="/" replace />} />
            <Route path="/b/report/:reportId" element={<RedirectToReport />} />
            <Route path="/b/research" element={<Navigate to="/research" replace />} />
            <Route path="/b/bookmarks" element={<Navigate to="/bookmarks" replace />} />

            {/* Original UI routes (available at /classic) */}
            <Route path="/classic" element={<SearchPage />} />
            <Route path="/classic/report/:reportId" element={<ResultsPage />} />
            <Route path="/classic/research" element={<ResultsPage />} />
          </Routes>
        </MediaPlayerProvider>
      </ArtistDataProvider>
    </BrowserRouter>
  );
}
